<template>
    <svg :width="size"
         :height="size"
         fill="none"
         stroke-linecap="round"
         stroke-linejoin="round"
         stroke-width="2"
         stroke="currentColor"
         viewBox="0 0 24 24">
        <path d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"></path>
    </svg>
</template>
<script>
    export default {
        props: {
            size: { type: [String, Number], default: 22 },
            color: { type: String, default: 'white' }
        }
    }
</script>
